function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-6 w-6 text-secondary-foreground"
      aria-hidden="true"
    >
      <path d="M20 6 9 17 4 12" />
    </svg>
  );
}

export function AccessRequestedFeedback() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-16 py-20">
      <div className="flex w-full max-w-[640px] flex-col items-center gap-5 text-center">
        <div
          aria-hidden="true"
          className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-secondary"
        >
          <CheckIcon />
        </div>

        <div className="flex w-full flex-col gap-[10px]">
          <h1 className="text-5xl font-semibold leading-none tracking-tight text-foreground">
            Acesso solicitado
          </h1>
          <p className="text-base leading-6 text-accent-foreground">
            Se a solicitação for aprovada, você recebe um e-mail em até 3 dias úteis. Se não receber
            nada nesse prazo, o acesso não foi liberado desta vez.
          </p>
        </div>
      </div>
    </div>
  );
}
